.list-container > *:not(:last-child) {
    margin-bottom: 16px;
}

.list-container--loading {
    height: 274px;
    width: 100%;
    background-color: var(--white);
}
